module.exports = __webpack_public_path__ + "img/letter_bg.18253698.png";